import { create } from 'zustand'

type InviteState = {
	// Whether the invite code modal should be shown
	needsInviteCode: boolean
	// Show the invite modal
	showInviteModal: () => void
	// Hide the invite modal (after successful registration)
	hideInviteModal: () => void
}

export const useInviteStore = create<InviteState>(set => ({
	needsInviteCode: false,
	showInviteModal: () => set({ needsInviteCode: true }),
	hideInviteModal: () => set({ needsInviteCode: false }),
}))
